import { Button, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useState } from 'react';

import { Organization } from '../../../organizations/types/organization.type';
import { InvoiceListTable } from '../Tables/InvoiceListTable.component';
import { CreateOrganizationInvoiceModal } from '../Modals/CreateOrganizationInvoiceModal.component';
import { ORGANIZATION_INVOICE_TABLE_HEADERS } from '../../constants/invoice-table-headers.constant';
import { InvoiceTypes } from '../../types/invoice-type.type';

const useStyles = makeStyles((theme) => ({
  root: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  header: { display: 'flex', justifyContent: 'flex-end' },
  triggerButton: {
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
}));

type Props = {
  organization: Organization;
};

export function OrganizationInvoicesTab({ organization }: Props) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshSignal, setRefreshSignal] = useState(0);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Button
          className={classes.triggerButton}
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => setModalOpen(true)}
        >
          Nouvelle facture
        </Button>
      </div>

      <InvoiceListTable
        headers={ORGANIZATION_INVOICE_TABLE_HEADERS}
        listParams={{ organizationId: organization.id, type: InvoiceTypes.ORGANIZATION }}
        refreshSignal={refreshSignal}
      />

      <CreateOrganizationInvoiceModal
        open={modalOpen}
        organization={organization}
        onClose={() => setModalOpen(false)}
        onCreated={() => setRefreshSignal((signal) => signal + 1)}
      />
    </div>
  );
}
